module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens8-9fc1a1404feefd2a3e34377f08f7fbb9.jpg";